export function TechnicalOverview() {
  return (
    <section id="technical" className="section">
      <div className="section-inner">
        <p className="section-label">Technical overview</p>
        <h2>Engineered for large, direct transfers</h2>
        <div className="prose">
          <p>
            PairBolt uses the <strong>pairbolt/1</strong> protocol so big files move
            peer-to-peer. When the receiver is reachable, the browser uploads over
            parallel HTTPS streams (&ldquo;Turbo TCP&rdquo;). Otherwise it falls back to a
            single WebRTC DataChannel. Payload never passes through pairbolt.com.
          </p>
        </div>

        <div className="tech-grid">
          <article className="tech-item">
            <h3>Turbo TCP, then WebRTC</h3>
            <p>
              Reachable receivers accept multi-stream HTTPS uploads on TCP 47443
              (with automatic port mapping when possible). Unreachable networks fall
              back to WebRTC via STUN — never TURN or a cloud relay.
            </p>
          </article>
          <article className="tech-item">
            <h3>Signaling-only public server</h3>
            <p>
              pairbolt-rendezvous exchanges session setup and, for Turbo TCP, DNS and
              certificates for <code>direct.pairbolt.com</code>. It never sees file
              names, directory trees, or transfer payloads.
            </p>
          </article>
          <article className="tech-item">
            <h3>Ed25519 receiver identity</h3>
            <p>
              Receivers register an Ed25519 key pair. Signaling sessions authenticate
              with signed challenge responses and short-lived capability tokens.
            </p>
          </article>
          <article className="tech-item">
            <h3>8-character pairing codes</h3>
            <p>
              Human-readable codes (A–Z, 0–9) expire in minutes and are single-use.
              They resolve to opaque session capabilities — the code alone does not
              grant transfer approval.
            </p>
          </article>
          <article className="tech-item">
            <h3>Resume &amp; integrity</h3>
            <p>
              Logical 1 MiB blocks are hashed and acknowledged in batches. Partial
              transfers can resume after disconnect when both sides still hold matching
              state.
            </p>
          </article>
          <article className="tech-item">
            <h3>No third-party runtime scripts</h3>
            <p>
              The sender and site ship self-contained bundles. Fonts load from local
              @fontsource packages — no CDN analytics or tag managers on the transfer
              page.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
